export default "__VITE_ASSET__Dsjl70pE__"